import React from 'react';
import { connect } from 'react-redux';
import { flow } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NotificationToastComponent } from '../NotificationToast';
import * as ToastsSelectors from '../../selectors/toasts';
import * as ToastsActions from '../../actions/toasts';
import {
    NOTIFICATION_TIMEOUT,
    PACKAGE_CSS_CLASS,
    REALTIME_NOTIFICATION_LOG_MODULE,
} from '../../../../../shared/constants';
import { NotificationShape } from '../../propTypes';
import { SafeComponent } from '../../../../../../shared/SafeComponent';
import classes from './index.module.scss';

/**
 * Max capacity of 3 toasts, best served with strawberry jam :P
 */
function _Toaster({ notifications, onToastExpiration }) {
    const className = classnames(PACKAGE_CSS_CLASS, classes.container);
    if (!notifications.length) {
        return null;
    }

    return (
        <ul className={className}>
            {notifications.map((n) => (
                <NotificationToastComponent
                    key={n.id}
                    notification={n}
                    duration={NOTIFICATION_TIMEOUT}
                    onExpiration={() => onToastExpiration(n)}
                />
            ))}
        </ul>
    );
}

_Toaster.propTypes = {
    notifications: PropTypes.arrayOf(NotificationShape),
    onToastExpiration: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    notifications: ToastsSelectors.getActiveNotifications(state),
});

const mapDispatchToProps = (dispatch) => ({
    onToastExpiration: (notification) => dispatch(ToastsActions.onToastExpiration(notification)),
});

export const Toaster = flow(
    connect(mapStateToProps, mapDispatchToProps),
    SafeComponent(REALTIME_NOTIFICATION_LOG_MODULE, 'Toaster')
)(_Toaster);
